import * as yup from 'yup';

export const inviteUserSchema = yup.object().shape({
  firstName: yup.string().required('First name is required field'),
  lastName: yup.string().required('Last name is required field'),
  companyEmail: yup.string().email('Invalid email').required('Company email is required field'),
});
